export { AtnUploadDataDialogComponent as Component } from './upload-data-dialog.component'
